/**
 * Shared KPI + chart option catalogues for the configurable slide templates.
 * `value` fields match backend expectations (MetricsResponse keys, /chart type
 * param); `label` fields are human-readable and used in the panel UI.
 */

export const METRIC_OPTIONS = [
  { value: "arr", label: "ARR" },
  { value: "mrr", label: "MRR" },
  { value: "totalRevenue", label: "Total Revenue" },
  { value: "grossMargin", label: "Gross Margin" },
  { value: "burnRate", label: "Burn Rate" },
  { value: "runway", label: "Runway" },
  { value: "cashBalance", label: "Cash Balance" },
  { value: "headcount", label: "Headcount" },
  { value: "netIncome", label: "Net Income" },
] as const;

export type MetricKey = (typeof METRIC_OPTIONS)[number]["value"];

export const CHART_OPTIONS = [
  { value: "revenue", label: "Revenue" },
  { value: "revenue_vs_expenses", label: "Revenue vs Expenses" },
  { value: "pnl_summary", label: "P&L Summary" },
  { value: "cash_balance", label: "Cash Balance" },
  { value: "burn", label: "Burn Rate" },
  { value: "expense_breakdown", label: "Expense Breakdown" },
  { value: "headcount", label: "Headcount" },
] as const;

export type ChartKey = (typeof CHART_OPTIONS)[number]["value"];

export const HISTORY_MONTH_OPTIONS = [
  { value: "6", label: "6 months" },
  { value: "12", label: "12 months" },
  { value: "24", label: "24 months" },
] as const;
